<template>
	<div class="section-integral">
		<v-flex class="newwarning--text title-integral" text-xs-center>Nuestra solución es un software de gestión integral para empresas, que incluye canales
			<span class="w-bold primary--text">Venta Online y Offline + Facturación Electrónica</span></v-flex>
		<v-flex text-xs-center class="newwarning--text mt-3 subtitle-integral">
			Si deseas contratar más productos, tenemos diversos planes para ayudarte
		</v-flex>
		<v-flex class="layout h-100 mt-5" mt-4 justify-center wrap>
			<v-flex v-for="(item, index) in integrations" :key="index" sm12 md3>
				<v-layout align-center column class="h-100 mg-left">
					<v-flex
						text-xs-center
						class="item-integral"
						@click="changeShow(item)"
						:class="{'select-section-plans': item.show}"
					>
						<div class="br-mobile" text-xs-left xs2>
							<img :src="item.image" alt="" height="35px">
						</div>
						<p
						:class="{'title-plan-select': item.show}"
						class="w-bold name-integral" xs9>
								{{ item.name }}
						</p>
							<button class="mobile-btn-arrow">
								<img
									:class="{'rotate-icon': !item.show}" 
									src="/static/images-new/sections/right-arrow.svg" 
									alt="flecha">
							</button>
					</v-flex>
					<v-flex
					:class="[item.show ? 'show' : 'not-show']"
					class="content-items h-100">
						<v-layout align-start column wrap>
							<v-flex v-for="(int, index) in item.sections" :key="index" class="mb-2">
								<img src="/static/images-new/icons/check-orange.svg" alt="" height="20">
								<span class="ml-2 fs-16 newwarning--text">{{ int.name }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<img :src="item.image" alt="image-int" class="image-integral br-desktop">
				</v-layout>
			</v-flex>
		</v-flex>
		<v-layout row align-center class="content-arrow">
			<v-flex class="br-desktop br-mobile">
				<img src="/static/images-new/sections/arrow-left.svg" alt="">
			</v-flex>
			<v-flex class="w-bold newwarning--text mt-5 size-mobile" text-xs-center>
				Medios de Pago y Soluciones Delivery
			</v-flex>
			<v-flex ml-3 class="br-desktop br-mobile">
				<img src="/static/images-new/sections/arrow-right.svg" alt="">
			</v-flex>
		</v-layout>
		<v-flex xs12 text-xs-center mt-2 class="br-desktop">
			<a :href="whatsappLink" target="_blank" class="href-depressed">
				<button class="href-wssp w-bold">
					<v-layout align-center>
						<v-flex>
							<img src="/static/images-new/icons/whatsapp-white.svg" alt="">
						</v-flex>
						<v-flex class="ml-3 text-wssp" text-xs-left>
							Deseo más información
						</v-flex>
					</v-layout>
				</button>
			</a>
		</v-flex>
	</div>	
</template>

<script>
function changeShow({ id }) {
	const index = this.integrations.findIndex(p => p.id === id);
	if (index > -1) {
		this.integrations[index].show = !this.integrations[index].show;
	}
}

function whatsappLink() {
	const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	if (reg.test(navigator.userAgent)) {
		return `https://api.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER_PE}&text=Hola he visto el plan gratuito y deseo mas información`;
	}
	return `https://web.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER_PE}&text=Hola he visto el plan gratuito y deseo mas información`;
}

function data() {
	return {
		integrations: [
			{
				id: 1,
				name: 'Venta Online',
				image: '/static/images-new/icons/image-int-1.svg',
				show: false,
				sections: [
					{
						id: 1,
						name: 'App Whitelabel',
					},
					{
						id: 2,
						name: 'Ecommerce Web',
					},
					{
						id: 3,
						name: 'MarketPlace',
					},
					{
						id: 4,
						name: 'Tienda Virtual',
					},
					{
						id: 5,
						name: 'WhatsApp Center',
					},
				],
			},
			{
				id: 2,
				name: 'Facturación Electrónica',
				image: '/static/images-new/icons/image-int-2.svg',
				show: false,
				sections: [
					{
						id: 1,
						name: 'App /Web',
					},
					{
						id: 2,
						name: 'Hadwares en punto de Venta',
					},
					{
						id: 3,
						name: 'Sistema Cloud: AWS',
					},
					{
						id: 4,
						name: 'Integrado a los canales de venta online/offline',
					},
				],
			},
			{
				id: 3,
				name: 'Gestión de Negocio',
				image: '/static/images-new/icons/image-int-3.svg',
				show: false,
				sections: [
					{
						id: 1,
						name: 'Control de Stock',
					},
					{
						id: 2,
						name: 'Gestión logística',
					},
					{
						id: 3,
						name: 'Módulo de Compra/Venta/Proveedores',
					},
					{
						id: 4,
						name: 'Modúlo de Tesorería Bancos/Caja',
					},
					{
						id: 5,
						name: 'Reportes',
					},
				],
			},
			{
				id: 4,
				name: 'Venta Tienda Física',
				image: '/static/images-new/icons/image-int-4.svg',
				show: false,
				sections: [
					{
						id: 1,
						name: 'App de Gestión',
					},
					{
						id: 2,
						name: 'Módulo de Gestión de Mercadería: Reposición y Devolución',
					},
					{
						id: 3,
						name: 'Módulo de Inventario: Incluye toma física',
					},
					{
						id: 4,
						name: 'Sistema Cloud: AWS',
					},
					{
						id: 5,
						name: 'Cierre de Caja',
					},
					{
						id: 6,
						name: 'Reportes',
					},
				],
			},
		],
	};
}

export default {
	name: 'section-integral-management',
	data,
	computed: {
		whatsappLink,
	},
	methods: {
		changeShow,
	},
};
</script>

<style lang="scss" scoped>
.section-integral {
	background-image: linear-gradient(to bottom, #ffffff 17%, #f5fbfb);
	padding: 70px 9% 30px 9%;

	@media (min-width: 986px) {
		padding: 83px 10% 70px 10%;
	}
}

.item-integral {
	border: solid 3px color(orange-cat);
	border-radius: 35.5px;
	color: color(orange-cat);
	margin-left: 20px;
	padding: 11px 0;
	text-align: center;
	width: 285px;

	&:first-child {
		margin-left: 0;
	}

	@media (max-width: 936px) {
		align-items: center;
		color: #02979b;
		border: 3px solid #02979b;
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
		padding: 5px 20px 5px 10px;
		width: 100%;
	}
}

.content-items {
	background-color: color(white);
	border-radius: 19px;
  	box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
	height: auto;
	margin: 5px 0 24px 0;
	padding: 15px;
	width: 100%;

	@media (min-width: 936px) {
		height: 357px;
		margin-top: 40px;
		padding: 35px 15px 0 25px;
	}
}

.mg-left {
	@media (min-width: 936px) {
		margin-right: 17px;	
	}
}

.image-integral {
	bottom: 40px;
	position: relative;
}

.href-wssp {
	background: #64b161;
	border-radius: 25.5px;
	box-shadow: 0 2px 6px 0 rgba(158, 158, 158, 0.5);
	color: map-get($colors, white);
	padding: 9px 9px 9px 22px;
	text-decoration: none;
	width: 245px;
}

.content-arrow {
	bottom: 40px;
	position: relative;
}

.size-mobile {
	@media (max-width: 936px) {
		font-size: 18px;
	}
}

.mobile-btn-arrow {
	display: none;

	@media (max-width: 936px) {
		display: block;
	}
}

.show {
	@media (max-width: 936px) {
		display: block;
	}
}

.not-show {
	@media (max-width: 936px) {
		display: none;
	}
}

.select-section-plans {
	@media (max-width: 936px) {
		border: 2px solid color(newprimary);
	}
}

.name-integral {
	margin-bottom: 0;
	font-size: 16px;

	@media (min-width: 936px) {
		font-size: 18px;
	}
}

.title-plan-select {
	@media (max-width: 936px) {
		color: color(newprimary);
	}
}

.title-integral {
	font-size: 14px;
	
	@media (min-width: 936px) {
		font-size: 27px;
	}
}

.subtitle-integral {
	font-size: 12px;

	@media (min-width: 936px) {
		font-size: 19px;	
	}
}

.rotate-icon {
	transform: rotate(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/home-new/section-integral-management.vue